import axios from 'axios';
// export const BaseUrl = `https://torbet-release.perla-tech.com`;
export const BaseUrl = (process.env.REACT_APP_BASE_URL || 'http://localhost:8069').replace(/\/$/, '');

export const buildBackendUrl = (path, fallback = '') => {
    if (path === undefined || path === null || path === false) return fallback;

    const normalizedPath = String(path).trim();
    if (!normalizedPath || normalizedPath === 'null' || normalizedPath === 'undefined') return fallback;
    if (/^(https?:)?\/\//i.test(normalizedPath) || /^data:/i.test(normalizedPath)) return normalizedPath;

    return `${BaseUrl}/${normalizedPath.replace(/^\/+/, '')}`;
};

export default axios.create({
    baseURL: `${BaseUrl}/`
    // baseURL: `https://torbet-release.perla-tech.com/`
    //baseURL: baseUrl
});
